import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useState, useMemo } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { removeDiacritics } from '../../../../../util/string.util';
import { OrderTypeFilter } from '../OrderTypeFilter';
import { OrderType, OrderUtil } from '../../../../../types/order/';

interface OrderTypeFilterContentProps {
  filter: OrderTypeFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

const orderTypeFilter = (type: string, text: string, filter: FilterProps) => {
  const filterText = removeDiacritics(text.toLowerCase());
  if (removeDiacritics(type.toLowerCase()).includes(filterText)) return true;
  return false;
};

export default function OrderTypeFilterContent({ filter, filterProps, setFilterProps }: OrderTypeFilterContentProps) {
  const [textFilter, setTextFilter] = useState<string>('');

  const values = useMemo(() => {
    return new Set([...Object.values(OrderType)].filter(type => filter.search(type, textFilter)));
  }, [textFilter, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.orderType = selected;
    if (!filterProps.orderType?.size) filterProps.orderType = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.orderType = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.orderType).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setTextFilter(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.orderType}
          values={values}
          onChange={handleChange}
          toText={id => OrderUtil.typeToString(id as OrderType)}
        />
      </Grid>
    </Grid>
  );
}
